
/* CHECKER48 SET UP OPTION | Dawn 16.1 */

(() => {
  if (window.C48SetupInstalled) return;
  window.C48SetupInstalled = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const productForm = form.closest('product-form');
    const option = productForm?.querySelector('.c48-setup-option');
    const checkbox = option?.querySelector('.c48-setup-option__checkbox');

    // チェックOFFの場合はDawnの通常購入処理
    if (!checkbox?.checked) return;

    // チェックONの場合はセット購入処理
    event.preventDefault();
    event.stopImmediatePropagation();

    const button = productForm.querySelector('[name="add"]');
    const select = option.querySelector('.c48-setup-option__select');

    const mainId = Number(
      form.querySelector('[name="id"]')?.value
    );
    const pairedId = Number(select?.value);

    const qtyField = document.querySelector(
      `#Quantity-${CSS.escape(productForm.dataset.sectionId)}`
    );

    const quantity = Math.max(
      1,
      Number(
        qtyField?.value ||
        form.querySelector('[name="quantity"]')?.value ||
        1
      )
    );

    const message = productForm.querySelector(
      '.product-form__error-message'
    );
    const errorWrapper = productForm.querySelector(
      '.product-form__error-message-wrapper'
    );

    const cart = document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    const selectedOption = select?.selectedOptions[0];

    if (
      !mainId ||
      !pairedId ||
      selectedOption?.disabled ||
      button?.disabled ||
      button?.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    productForm.querySelector('.loading__spinner')
      ?.classList.remove('hidden');

    errorWrapper?.setAttribute('hidden', '');

    try {
      const formData = new FormData(form);
      const properties = {};

      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.*)\]$/);
        if (match) {
          properties[match[1]] = value;
        }
      }

      const mainItem = {
        id: mainId,
        quantity
      };

      if (Object.keys(properties).length) {
        mainItem.properties = properties;
      }

      const payload = {
        items: [
          mainItem,
          {
            id: pairedId,
            quantity
          }
        ]
      };

      if (cart) {
        payload.sections = cart.getSectionsToRender()
          .map(section => section.id);

        payload.sections_url = window.location.pathname;

        cart.setActiveElement?.(document.activeElement);
      }

      const response = await fetch(
        window.routes.cart_add_url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(
          data.description ||
          data.message ||
          'セット商品の追加に失敗しました。'
        );
      }

      if (!cart) {
        window.location.assign(window.routes.cart_url);
        return;
      }


if (cart && typeof cart.renderContents === 'function') {
  // セット購入後の最新カートHTMLを取得
  const sectionIds = cart.getSectionsToRender()
    .map(section => section.id);


const sectionUrl = new URL(
  window.location.pathname,
  window.location.origin
);

sectionUrl.searchParams.set(
  'sections',
  sectionIds.join(',')
);

const sectionResponse = await fetch(
  sectionUrl.toString(),
    {
      credentials: 'same-origin',
      cache: 'no-store'
    }
  );

  if (!sectionResponse.ok) {
    throw new Error('カート表示の更新に失敗しました。');
  }

  const sections = await sectionResponse.json();

  // 必要なHTMLが取得できた場合だけ再描画
  if (
    sections['cart-drawer'] &&
    sections['cart-icon-bubble']
  ) {
    
cart.classList.remove('is-empty');

const drawerInner = cart.querySelector('.drawer__inner');
if (drawerInner) {
  drawerInner.classList.remove('is-empty');
}

cart.renderContents({
  ...data,
  sections
});

  } else {
    // HTMLが不足している場合はカートページへ移動
    window.location.assign(window.routes.cart_url);
  }
}


// 描画後に他のコンポーネントへ更新を通知
if (
  typeof publish === 'function' &&
  typeof PUB_SUB_EVENTS !== 'undefined'
) {
  Promise.resolve(
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'c48-setup',
      productVariantId: mainId,
      cartData: data
    })
  ).catch(console.error);
}

    } catch (error) {
      if (message) {
        message.textContent =
          error.message || 'セット購入に失敗しました。';
      }

      errorWrapper?.removeAttribute('hidden');

    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');

      productForm.querySelector('.loading__spinner')
        ?.classList.add('hidden');
    }
  }, true);
})();


/* CHECKER48 | SET UP OPTION PRICE */

(() => {
  const initSetupPrices = () => {
    document.querySelectorAll('.c48-setup-option').forEach((option) => {
      if (option.dataset.priceInitialized === 'true') return;

      const select = option.querySelector('.c48-setup-option__select');
      const price = option.querySelector('.c48-setup-option__price-value');

      if (!select || !price) return;

      option.dataset.priceInitialized = 'true';

      // CHECKER48 日本円・日本語表示
      const currency = 'JPY';
      const locale = 'ja-JP';

      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      });

      const updatePrice = () => {
        const selected = select.selectedOptions[0];
        if (!selected) return;

        // Shopifyの価格は100分の1単位
        const cents = Number(selected.dataset.price || 0);

        price.textContent = formatter.format(cents / 100);
      };

      select.addEventListener('change', updatePrice);

      // 初期価格を表示
      updatePrice();
    });
  };

  document.addEventListener('DOMContentLoaded', initSetupPrices);

  if (document.readyState !== 'loading') {
    initSetupPrices();
  }
})();
